<template>
  <div class="centerCenter">
    <div class="container text-center">
      <router-link to="/">
        <img
          class="d-block mx-auto mb-4"
          src="../assets/logo_default.svg"
          alt
          width="100"
          height="100"
        />
      </router-link>

      <form id="signinform" class="form-signin" @submit.prevent="setPassword">
        <h2 class="form-signin-heading py-3">Set your password.</h2>

        <label for="password" class="float-left">New password</label>
        <input
          v-model="password"
          type="password"
          id="password"
          class="form-control mb-4"
          placeholder="password"
          minlength="10"
          required
          autofocus
        />

        <button class="btn btn-lg btn-primary btn-block" type="submit">
          Make it so
        </button>
      </form>

      <div class="mt-3 text-small">
        Changed your mind?
        <router-link to="/login">Sign in here</router-link>
      </div>

      <slot name="footer"></slot>
    </div>
    <!-- /container -->

    <DialogError v-model="errorVisible" @hidden="errorHidden">{{
      errorMessage
    }}</DialogError>
    <DialogInfo v-model="infoVisible" title="Success" @hidden="dialogHidden">
      Your password for {{ username }} has been reset successfully. When you
      close this dialog, you will be redirected to the login page.
    </DialogInfo>
  </div>
</template>

<script>
import DialogInfo from "@/components/DialogInfo";
import DialogError from "@/components/DialogError";

export default {
  name: "PasswordReset",
  components: {
    DialogInfo,
    DialogError
  },
  created() {
    this.$emit("toggle-navbar", false);
    this.$emit("full-body", true);

    try {
      this.username = atob(this.$route.params.user);
      this.code = this.$route.params.code;
    } catch {
      this.errorMessage =
        "Sorry, there is an error with the reset data. Please request a new reset link!";
      this.errorVisible = true;
      return;
    }

    if (!this.username || !this.code) {
      this.$router.replace("/");
      return;
    }

    this.$topquiz.on(this, "resetPassword_error", params => {
      var error = params[0];
      if (error == -1) {
        this.errorMessage =
          "Sorry, that did not work. Please request a new reset link!";
        this.errorVisible = true;
        return;
      }

      this.errorMessage = error;
      this.errorVisible = true;
    });

    this.$topquiz.on(this, "resetPassword_success", () => {
      this.infoVisible = true;
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  data() {
    return {
      errorMessage: "",
      errorVisible: false,
      infoVisible: false,
      password: "",
      username: "",
      code: ""
    };
  },
  methods: {
    setPassword() {
      this.$topquiz.sendCommand(
        "resetPassword",
        this.username,
        this.code,
        this.password
      );
    },
    errorHidden() {
      this.$router.replace("/password");
    },
    dialogHidden() {
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 400px;
}
</style>
